import { Component, EventEmitter, Output } from '@angular/core';
import { EXAMPLE_SERIALS_CSV, parseSerialsCsv } from './serial-matching';

const MAX_FILE_BYTES = 5 * 1024 * 1024;

/** Button next to the device search: upload a CSV of serial numbers, or download an example. */
@Component({
  selector: 'app-serial-csv-upload',
  templateUrl: './serial-csv-upload.component.html',
  styleUrls: ['./serial-csv-upload.component.scss'],
  standalone: false
})
export class SerialCsvUploadComponent {
  /** Serials read from the file. */
  @Output() serialsLoaded = new EventEmitter<string[]>();
  /** Why a file could not be used. */
  @Output() failed = new EventEmitter<string>();

  async onFileSelected(input: HTMLInputElement): Promise<void> {
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;

    if (!/\.(csv|txt)$/i.test(file.name)) {
      this.failed.emit('Upload a .csv file with a "serial" column.');
      return;
    }
    if (file.size > MAX_FILE_BYTES) {
      this.failed.emit('The file is too large (5 MB maximum).');
      return;
    }

    const { serials, error } = parseSerialsCsv(await file.text());
    if (error || !serials.length) {
      this.failed.emit(error ?? 'The file has no serial numbers.');
      return;
    }
    this.serialsLoaded.emit(serials);
  }

  downloadExample(): void {
    const url = URL.createObjectURL(new Blob([EXAMPLE_SERIALS_CSV], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'serials-example.csv';
    link.click();
    setTimeout(() => URL.revokeObjectURL(url));
  }
}
